import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiSelect = {
  styleOverrides: {
    root: ({ theme }) => ({
      ".Mui-readOnly": {
        color: theme.palette.text.disabled,
        background: theme.palette.action.hover
      }
    }),
    select: ({ ownerState }) => ({
      fontSize: capitalDesignTokens.componentFontSizes.medium,
      ...ownerState.size === "small" && {
        minHeight: `${capitalDesignTokens.componentSizes.small}px`,
        fontSize: capitalDesignTokens.componentFontSizes.small
      },
      ...ownerState.size === "large" && {
        minHeight: `${capitalDesignTokens.componentSizes.large}px`,
        fontSize: capitalDesignTokens.componentFontSizes.large
      }
    })
  }
};
export {
  MuiSelect
};
//# sourceMappingURL=MuiSelect.js.map
